/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseSplitPanelDoubleImageBlockFragment} from '@amblique/contentful/app/contentful/fragments/split-panel-double-image-block/base-split-panel-double-image-block.fragment';
import {BaseImageFragment} from '@amblique/contentful/app/contentful/fragments/image/base-image.fragment';
import {BaseRichTextBlockFragment} from '@amblique/contentful/app/contentful/fragments/rich-text-block/base-rich-text-block.fragment';
import {BaseVideoFragment} from '@amblique/contentful/app/contentful/fragments/video/base-video.fragment';

export const SplitPanelDoubleImageBlockFragment = gql`
  ${BaseImageFragment}
  ${BaseRichTextBlockFragment}
  ${BaseSplitPanelDoubleImageBlockFragment}
  ${BaseVideoFragment}

  fragment SplitPanelDoubleImageBlockFragment on SplitPanelDoubleImageBlock {
    ...BaseSplitPanelDoubleImageBlockFragment

    primaryImage {
      ... on Image {
        ...BaseImageFragment
      }
      ... on Video {
        ...BaseVideoFragment
      }
    }
    contentCollection {
      items {
        __typename
        ... on Image {
          ...BaseImageFragment
        }
        ... on RichTextBlock {
          ...BaseRichTextBlockFragment
        }
        ... on Video {
          ...BaseVideoFragment
        }
      }
    }
  }
`;
